import { supabase } from './supabase';

export async function logActivity(
  action: string,
  entityType: 'quotation' | 'merchant' | 'bank' | 'dataset',
  entityId: string,
  entityName: string
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { error } = await supabase
      .from('activity_logs')
      .insert({
        user_id: user.id,
        action,
        entity_type: entityType,
        entity_id: entityId,
        entity_name: entityName
      });

    if (error) throw error;
  } catch (err) {
    console.error('Error logging activity:', err);
  }
}